import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CostVisibilityProvider } from "./context/CostVisibility";

import VehiclePage from "./pages/VehiclePage";
import ReportForm from "./pages/ReportForm";
import AdminLogin from "./pages/AdminLogin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminApp from "./pages/AdminApp";
import StampaQr from "./pages/StampaQr";
import Vetrina from "./pages/Vetrina";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Termini from "./pages/Termini";
import Privacy from "./pages/Privacy";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        Caricamento...
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" theme="dark" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Vetrina />} />
          <Route path="/vetrina" element={<Navigate to="/" replace />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/termini" element={<Termini />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/mezzo/:id" element={<VehiclePage />} />
          <Route path="/mezzo/:id/segnala" element={<ReportForm />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin/*" element={<Protected><CostVisibilityProvider><AdminApp /></CostVisibilityProvider></Protected>} />
          <Route path="/stampa-qr" element={<Protected><StampaQr /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
